
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"7.182","height":"10.677"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.684 5.378a.267.267 0 00-.034-.04.283.283 0 00.034-.039 5.659 5.659 0 002.943-4.5c.182-.267-.131-.3-.368-.3H.923c-.238 0-.55.032-.368.3a5.659 5.659 0 002.943 4.5.241.241 0 00.034.039.23.23 0 00-.034.04 5.658 5.658 0 00-2.943 4.5c-.182.267.131.3.368.3h5.336c.238 0 .55-.032.368-.3a5.659 5.659 0 00-2.943-4.5z","fill":"none","stroke":"#188038","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    